import React, { Component } from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import autosize from 'autosize'
import Radium from 'radium';

const propTypes = {}

const defaultProps = {
    text: '',
    editMode: true,
}

const styles = {
    subtextStyle: {
        fontSize: 14,
    },
    textarea: {
        resize: 'none',
        width: '100%',
        border: 'none',
        outline: 'none',
        paddingLeft: 5,
        height: 25,

    },
    preWrap: {
        wordBreak: 'break-all',
        whiteSpace: 'pre-wrap',
        width: '100%',
        minHeight: 25,
        paddingLeft: 5,
        paddingTop: 2,
        paddingBottom: 7,
    },
}

class Subtext extends Component {

    componentDidUpdate() {
        autosize($('textarea'));
    }

    toggleEditMode = () => {
        this.props.setEditMode(true, '2')
        setTimeout(() => this.myInp ? this.myInp.focus() : () => { }, 100)
    }

    onBlur = () => {
        const { text } = this.props
        if (text.length > 0) {
            this.props.setEditMode(!this.props.editMode, '2')
        }
    }

    onChange = (e) => {
        const { onChange } = this.props
        onChange(e.target.value)
    }

    render() {
        const { text, style } = this.props
        return (
            <div
                style={styles.subtextStyle}
                onClick={this.toggleEditMode}>
                {
                    this.props.editMode ?
                        <textarea
                            style={[styles.textarea, style]}
                            value={text}
                            placeholder="Beskrivelse"
                            onChange={this.onChange}
                            onBlur={this.onBlur}
                            ref={(ip) => this.myInp = ip}
                            onFocus={this.toggleEditMode}
                        /> :
                        <div
                            style={[styles.preWrap, style]}>
                            {text}
                        </div>
                }
            </div>
        )
    }
}

Subtext.propTypes = propTypes

Subtext.defaultProps = defaultProps

export default Radium(Subtext)



// WEBPACK FOOTER //
// ./src/App/HeadingSubtext/Subtext.js